<template>
  <CsrPage class="vs-csr-page" />
</template>

<script>
import CsrPage from '@/scripts/pages/csr/index.ts.vue';

/**
 * This is the entry for the page "Corporate Social Responsibility (CSR), aka Viddsee for Good"
 */
export default {
  components: {
    CsrPage,
  },
};
</script>

<style lang="scss">
body > .banner.clearfix.hidden-sm-up {
  display: none;
}
</style>

<style lang="scss">
.vs-csr-page {
  @import '~@/scripts/pages/onepager/styles/entry';

  font-size: 16px;
  line-height: 1.5;
  color: #212529;

  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn {
    font-weight: bold;
  }
}
</style>
